import tinycolor from "tinycolor2";
import { getSessionId } from "../../client/sessionSetup";
import { sendKafkaEvent } from "../../client/wss";

export const PaymentQuery = ({ botDetails }) => {
    const cartPath =
    botDetails.storeName === "Bigcommerce"
      ? "/checkout.php"
      : botDetails.storeName === "Shopify"
      ? "/checkout"
      : "";
      const isColorDark = (color) => {
        const colorObj = tinycolor(color);
        return colorObj.isDark();
      };
    
  return (
    <div style={{ display: "flex", gap: "5px", alignItems: "center" }}>
      Show Payment Details
      <button
        style={{
          background: `${botDetails.accentColor}`,
          color: isColorDark(botDetails.accentColor)?"white":"black",
          borderRadius: "10px",
          padding: "4px",
        }}
        className="ulai-add-to-cart-button"
        onClick={() => {
          sendKafkaEvent({
            eventName: "websdk_view_cart",
            userId: botDetails.userId,
            sessionId: getSessionId(localStorage.getItem("sessionUUID")),
          });
          window.parent.postMessage({ type: "checkoutHref",cartPath }, "*");
        }}
      >
        Checkout
      </button>
    </div>
  );
};
